import { PASS_MIN_LENGTH } from 'constants/auth';

export const PASS_VALIDATION_KEYS = {
  LOWERCASE: 'lowercase',
  UPPERCASE: 'uppercase',
  NUMBER: 'number',
  SPECIAL: 'special',
  LENGTH: 'length',
};

export const passValidationData = [
  {
    key: PASS_VALIDATION_KEYS.LOWERCASE,
    caption: 'One lowercase character',
    regex: /[a-z]/,
  },
  {
    key: PASS_VALIDATION_KEYS.SPECIAL,
    caption: 'One special character',
    regex: /\[|]|[~!@#$%^&*()_\-+{}"ª',`:<>.;º¡™£€/∞§|¶–?•≠=«πøˆ¨¥†®´∑œåß∂ƒ©˙∆˚¬…æ÷≥≤µ˜∫√ç≈Ω¢\\ ]/,
  },
  {
    key: PASS_VALIDATION_KEYS.NUMBER,
    caption: 'One number',
    regex: /\d/,
  },
  {
    key: PASS_VALIDATION_KEYS.UPPERCASE,
    caption: 'One uppercase character',
    regex: /[A-Z]/,
  },
  {
    key: PASS_VALIDATION_KEYS.LENGTH,
    caption: `${PASS_MIN_LENGTH} characters minimum`,
    regex: /.{12,}/,
  },
];

export const passwordValidationRules = passValidationData.reduce(
  (acc, { key, regex }) => ({
    ...acc,
    [key]: (value) => regex.test(value),
  }),
  {},
);
